import { ParagraphMd } from '@olist/design-system';
import styled, { keyframes } from 'styled-components';

const loadingrotate = keyframes `
  100% {
    transform: rotate(360deg);
  }
`;
const loadingdash = keyframes `
  0% {
    stroke-dasharray: 1,200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 100,200;
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dasharray: 200,200;
    stroke-dashoffset: -185;
  }
`;
const LoadingDirective = styled.div `
  position: relative;
  margin: 0 auto;
`;
const Loader = styled.div `
  position: absolute;
  clear: both;
  display: block;

  top: -44px;
  left: -66px;
`;
const Svg = styled.svg `
  width: 110px;
  height: 110px;
  transform: rotate(270deg);
`;
styled.div `
  animation: ${loadingrotate} 2s linear infinite;
  position: relative;
`;
const CircleBottomLayer = styled.circle `
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  stroke-width: 15;
  animation: ${loadingdash} 1.2s ease-in-out infinite;
  stroke-linecap: round;
  stroke: #93f3d4;
`;
const CircleMiddleLayer = styled(CircleBottomLayer) `
  stroke: #364ef7;
  animation-delay: 100ms;
`;
const CircleTopLayer = styled(CircleBottomLayer) `
  stroke: #0c29d0;
  animation-delay: 200ms;
`;
const PageLoadingContainer = styled.main `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;
const CustomParagraphMd = styled(ParagraphMd) `
  max-width: 28ch;
  text-align: center;
  word-break: break-word;
`;

export { CircleBottomLayer, CircleMiddleLayer, CircleTopLayer, CustomParagraphMd, Loader, LoadingDirective, PageLoadingContainer, Svg };
